import { ArrowLeft } from "lucide-react";
import { Card } from "@/projects/Admin_Bite_Balance/bite-balance/src/components/ui/card";
import { Button } from "@/projects/Admin_Bite_Balance/bite-balance/src/components/ui/button";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

const MealHistory = () => {
  const navigate = useNavigate();
  const [selectedDate] = useState(new Date());

  const historyData = [
    {
      date: "Today",
      calories: 1740,
      protein: 98,
      carbs: 175,
      fat: 63,
      meals: 4,
    },
    {
      date: "Yesterday",
      calories: 1890,
      protein: 95,
      carbs: 182,
      fat: 60,
      meals: 4,
    },
    {
      date: "2 days ago",
      calories: 2100,
      protein: 110,
      carbs: 200,
      fat: 72,
      meals: 5,
    },
    {
      date: "3 days ago",
      calories: 1980,
      protein: 105,
      carbs: 190,
      fat: 68,
      meals: 4,
    },
  ];

  return (
    <div className="min-h-screen bg-background pb-24">
      <div className="mx-auto max-w-md">
        {/* Header */}
        <div className="flex items-center gap-3 border-b border-border/50 p-4">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => navigate("/meals")}
            className="rounded-xl"
          >
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <div className="flex-1">
            <h1 className="text-xl font-bold text-foreground">Meal History</h1>
            <p className="text-xs text-muted-foreground">
              {selectedDate.toLocaleDateString("en-US", {
                month: "long",
                year: "numeric",
              })}
            </p>
          </div>
          <div className="w-10" />
        </div>

        <div className="space-y-4 p-4">
          {historyData.map((day, index) => (
            <Card
              key={index}
              className="cursor-pointer rounded-2xl border-2 border-primary/20 bg-card p-5 shadow-md transition-all hover:border-primary/40 hover:shadow-lg"
            >
              <div className="mb-4 flex items-center justify-between">
                <div>
                  <h3 className="text-lg font-bold text-foreground">
                    {day.date}
                  </h3>
                  <p className="text-sm font-semibold text-muted-foreground">
                    {day.meals} meals logged
                  </p>
                </div>
                <div className="text-right">
                  <div className="text-3xl font-bold text-primary">
                    {day.calories}
                  </div>
                  <p className="text-sm font-bold text-muted-foreground">
                    kcal
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-3 gap-3">
                <div className="bg-chart-1/10 border-chart-1/30 rounded-lg border-2 py-3 text-center">
                  <div className="text-chart-1 text-base font-bold">
                    {day.protein}g
                  </div>
                  <div className="text-xs font-bold text-muted-foreground">
                    Protein
                  </div>
                </div>
                <div className="bg-chart-2/10 border-chart-2/30 rounded-lg border-2 py-3 text-center">
                  <div className="text-chart-2 text-base font-bold">
                    {day.carbs}g
                  </div>
                  <div className="text-xs font-bold text-muted-foreground">
                    Carbs
                  </div>
                </div>
                <div className="bg-chart-3/10 border-chart-3/30 rounded-lg border-2 py-3 text-center">
                  <div className="text-chart-3 text-base font-bold">
                    {day.fat}g
                  </div>
                  <div className="text-xs font-bold text-muted-foreground">
                    Fat
                  </div>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MealHistory;
